import { HttpClient } from "@angular/common/http";
import { Component, inject, input } from "@angular/core";
import { ReportWizardComponent } from "./report-wizard/report-wizard.component";

@Component({
    selector: "subscription-report",
    imports: [ReportWizardComponent],
    templateUrl: "./subscription-report.component.html",
    styleUrl: "./subscription-report.component.scss",
})
export class SubscriptionReportComponent {
    canNotShowStatisticsMessage = input<string>("");

    infoToggleOpen: boolean = false;
    showSubscriptionsReportWizard: boolean = false;
    exampleTrendReportUrlUrl = "assets/ukesrapport.pdf";
    httpClient = inject(HttpClient);

     openExamplePdf(): void {
        this.httpClient.get(this.exampleTrendReportUrlUrl, { responseType: "blob" }).subscribe((data) => {
            const file = new Blob([data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);

            // if you want to open PDF in new tab
            window.open(fileURL);
            // ------
            const a = document.createElement("a");
            a.href = fileURL;
            a.target = "_blank";
            a.download = "ukesrapport.pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
    }

    openDialog(): void {
        this.showSubscriptionsReportWizard = true;
        // this.globalStateService.updateSidebar(SidebarModel.None);
    }

    closeDialog(): void {
        this.showSubscriptionsReportWizard = false;
        // this.globalStateService.updateSidebar(SidebarModel.Statistics);
    }
}
